<template>
    <div>
        <form class="shaded m-5" @submit.prevent.stop="save" novalidate>
            <div class="form-group row">
                <div class="col-sm-4" :class="{ error: $v.form.name.$error }">
                    <label class="full">
                        Name
                        <span class="brand">
                            *
                        </span>
                        <input type="text" v-model="form.name" @input="$v.form.name.$touch">
                    </label>

                    <div v-if="$v.form.name.$error" class="messages">
                        <span v-if="!$v.form.name.required">Name is required.</span>
                        <span v-if="!$v.form.name.minLength">Name must have at least 3 characters.</span>
                    </div>
                </div>
                <div class="col-sm-2">
                    <label class="full">
                        Code
                        <input type="text" v-model="form.code">
                    </label>
                </div>
                <!-- <div class="col-sm-3">
                    <label class="d-flex align-items-center ml-5 py-4">
                        Active
                        <toggle-button
                            class="ml-3"
                            v-model="form.isActive"
                            :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </label>
                </div> -->
            </div>

            <div v-if="types" class="form-group row">
                <div class="col-sm-4">
                    <label class="full">Type</label>

                    <v-select
                        v-model="selectedType"
                        :options="types"
                        placeholder="- Select resource type -"
                        :searchable="true"
                        label="description"
                        @input="updateType">
                    </v-select>
                </div>
                 <div class="col-sm-2">
                    <label class="full">
                        Max. Capacity
                        <input type="text" v-model="form.availability">
                    </label>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-sm-9">
                    <label class="full">
                        Description (Optional)
                        <textarea v-model="form.description"></textarea>
                    </label>
                </div>
            </div>


            <div class="form-group row">
                <!-- <div class="col-sm-6">
                    <label class="full">
                        <checkbox v-model="form.limited">
                            This resource has limited availability
                        </checkbox>
                    </label>
                    <label class="full">
                        <checkbox v-model="form.sharedBetweenProducts">
                            Availability can be shared between products
                        </checkbox>
                    </label>
                    <label class="full">
                        <checkbox v-model="form.sharedBetweenBookings">
                            Availability can be shared between bookings
                            (unselect if this is used only for privates)
                        </checkbox>
                    </label>

                </div> -->

            </div>

        </form>
    </div>

</template>

<script>
    import { mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import { required, minLength } from 'vuelidate/lib/validators'

    export default {
        data: function() {
            return {
                form: {
                    name: '',
                    type: null,
                    isActive: true,
                    limited: true,
                    sharedBetweenProducts: true,
                    sharedBetweenBookings: true
                },
                selectedType: null,
            }
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3),
                },
            }
        },
        created: function() {
            if (this.getSelectedItem) {
                this.form = JSON.parse(JSON.stringify(this.getSelectedItem));
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedItem'
            ]),
        },
        asyncComputed: {
            async types() {
                try {
                    let response = await axios.get('/api/settings/GetResourceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects

                        if (this.form.type) {
                            this.selectedType = response.data.find(item => item.id === this.form.type);
                        }
                        else {
                            this.selectedType = response.data[0];
                            this.form.type = response.data[0].id;
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        methods: {
            updateType: function() {
                this.form.type = this.selectedType.id || null;
            },
        },
        watch: {
            $v: {
                handler: function (n, o) {
                    var toggleIsDisabled = (n.form.$invalid || n.form.$error) ? true : false;

                    this.$emit('toggleIsDisabled', toggleIsDisabled);

                    // Can we save? Have all validations been passed?
                    // Then we'll send the 'actual' form so we can
                    // set it as selectedItem

                    if (!toggleIsDisabled) {
                        this.$emit('readyToSave', this.form);
                    }
                },
                deep: true
            }
        },
        components: {
            vSelect: extendedVSelect
        }
    }
</script>



// WEBPACK FOOTER //
// ResourceForm.vue?48e5044d